import {useEffect,useRef,useState} from 'react';
import {ArrowUpRight} from './Icons';
import {cases} from './content';

/** 案例库与客户端同一套:回放子应用(public/showcase)整段嵌入,列表、播放和样式都来自客户端。 */
declare const __BUILD_ID__:string;
const SHOWCASE_URL=`/showcase/index.html?v=${__BUILD_ID__}`;

function requestedCaseId():string|undefined{
 if(typeof window==='undefined')return undefined;
 let id:string;
 try{id=decodeURIComponent(window.location.hash.slice(1))}catch{return undefined}
 return cases.some(c=>c.id===id)?id:undefined;
}

export function CaseReplay(){
 const [src,setSrc]=useState<string|null>(null);
 const [playing,setPlaying]=useState(false);
 const [expanded,setExpanded]=useState(false);
 const [height,setHeight]=useState(0);
 const [failed,setFailed]=useState(false);
 const frame=useRef<HTMLIFrameElement>(null);
 // 客户端渲染后再挂 iframe:预渲染的 HTML 不带它,无脚本环境看到下方的下载入口。
 useEffect(()=>{
  const apply=()=>{const id=requestedCaseId();setSrc(id?`${SHOWCASE_URL}&case=${encodeURIComponent(id)}`:SHOWCASE_URL);setPlaying(Boolean(id))};
  apply();
  window.addEventListener('hashchange',apply);
  return()=>window.removeEventListener('hashchange',apply);
 },[]);
 // 全屏时藏起站点导航与悬浮客服，并锁住页面滚动，别压在回放上面。
 useEffect(()=>{
  const root=document.documentElement;
  root.classList.toggle('showcase-expanded',expanded);
  return()=>root.classList.remove('showcase-expanded');
 },[expanded]);
 // 子页面播放时占整块高度，回到列表只留一屏卡片。
 useEffect(()=>{
  const onMessage=(event:MessageEvent)=>{
   if(event.origin!==window.location.origin||event.source!==frame.current?.contentWindow)return;
   const data=event.data as{type?:unknown;playing?:unknown;height?:unknown;expanded?:unknown};
   // 预览全屏:把嵌入的 iframe 提成整窗，退出再放回页面里。
   if(data?.type==='sciland-showcase-expand'){setExpanded(data.expanded===true);return}
   if(data?.type!=='sciland-showcase-state')return;
   setPlaying(data.playing===true);
   // 列表态按子页面实测内容高度，避免卡片下方留白。
   if(typeof data.height==='number'&&Number.isFinite(data.height))setHeight(Math.min(2400,Math.max(280,data.height)));
  };
  window.addEventListener('message',onMessage);
  return()=>window.removeEventListener('message',onMessage);
 },[]);
 return <section className="container case-replay" aria-labelledby="case-replay-title">
  <h2 id="case-replay-title" className="sr-only">案例库</h2>
  {src&&!failed&&<iframe ref={frame} className={`case-replay-frame ${playing?'is-playing':''} ${expanded?'is-expanded':''}`} style={!playing&&!expanded&&height?{height:`${height}px`}:undefined} src={src} title="Sciland 案例库：从头回放完整研究过程" onError={()=>setFailed(true)}/>}
  {failed&&<p role="alert" className="case-replay-fallback">案例回放暂时无法加载。<a className="text-link" href="/download">下载客户端查看完整案例 <ArrowUpRight aria-hidden="true" size={14}/></a></p>}
  <noscript><p className="case-replay-fallback">案例回放需要开启 JavaScript；也可以<a className="text-link" href="/download">下载客户端</a>查看完整研究过程。</p></noscript>
 </section>;
}
